export enum CompanyType {
  CCorpNonProfitOrMunicipality = 1,
  Scorp = 2,
  Partnership = 3,
  SoleProprietors = 4,
  LLCFilingAsSCorp = 5,
  LLCFilingAsPartnership = 6,
}
